module.exports = __webpack_public_path__ + "img/envia.bf985c39.svg";